module.exports = __webpack_public_path__ + "static/media/align-justify.08fe2b6f.svg";